export default __webpack_public_path__ + "static/filter-9b6451d7e70858582027ae4b3e33c892.png";